import { render, staticRenderFns } from "./property.vue?vue&type=template&id=0fe01fdc&"
import script from "./property.vue?vue&type=script&lang=js&"
export * from "./property.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fe01fdc')) {
      api.createRecord('0fe01fdc', component.options)
    } else {
      api.reload('0fe01fdc', component.options)
    }
    module.hot.accept("./property.vue?vue&type=template&id=0fe01fdc&", function () {
      api.rerender('0fe01fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/property.vue"
export default component.exports